module.exports = __webpack_public_path__ + "assets/img/saules-elektrines-slaitinis-stogas.bb4d173c.webp";